import React, { useState, useEffect, useContext } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { BasketContext } from 'layouts/aaro/fastPrice';
import AddIcon from '@mui/icons-material/Add';
import MDBox from 'components/MDBox';
import Icon from '@mui/material/Icon';

import { getStockPrice } from 'services/outside/aaro/priceList';
import { notify } from 'helpers/notificationHelper';
import MDButton from 'components/MDButton';
import { todayIsBetween } from 'helpers/dateHelpers';
// import aa from 'search-insights';

const fetchAaroStockPrice = async (stokID) => {
    const response = await getStockPrice(stokID).then((rp) => rp.data);
    return response;
};

function AddToBasket({
    stockID,
    Price = 0,
    Amount = 1,
    Discount = 0,
    Tax = 20,
    stockName = '',
    sku = '',
    setOpen,
    queryID,
    objectID,
}) {
    const { basket, setBasket } = useContext(BasketContext);
    const queryClient = useQueryClient();
    const [shouldFetch, setShouldFetch] = useState(false);

    const indexName = 'improvedProd';

    // Use useQuery to reactively get price data
    const { data: priceData } = useQuery({
        queryKey: ['fetchAaroStockPrice', stockID],
        queryFn: () => fetchAaroStockPrice(stockID),
        enabled: shouldFetch,
        staleTime: 60 * 1000,
        refetchOnWindowFocus: false,
    });

    const handleBasket = (data) => {
        try {
            const currentBasket = {
                id: stockID,
                Price: data.Price ? data.Price : Price,
                Amount,
                Discount,
                Tax,
                StokID: stockID,
                StokKodu: data.StokKodu,
                StokAdi: data.StokAdi,
                // Store complete Aaro Model data as JSON string
                aaroData: data.aaroCompleteData ? JSON.stringify(data.aaroCompleteData) : null,
            };
            const previousData = [...basket];

            const newBasket = [...previousData.filter((item) => item.StokID !== currentBasket.StokID), currentBasket];

            setBasket(newBasket);
            notify(true, 'Sepete Eklendi');
            setOpen && setOpen(false);
        } catch (error) {
            notify(false, 'Sepete Eklenirken Hata Oluştu');
            console.error('Basket error:', error);
        }
    };

    const user = JSON.parse(localStorage.getItem('user'));

    const handleClick = () => {
        // Analytics tracking
        queryID &&
            window.aa('convertedObjectIDsAfterSearch', {
                eventName: 'Product Added to Cart',
                index: indexName,
                userToken: user.userID,
                objectIDs: [objectID],
                queryID: queryID,
            });

        // Get price data and add to basket
        const model = priceData?.Model ? priceData.Model[0] : {};
        const isValid = todayIsBetween(new Date(model?.TarihBas), new Date(model?.TarihBit));
        const item = isValid
            ? {
                  Price: model?.Fiyat,
                  StokKodu: model?.StokKodu,
                  StokAdi: model?.StokAdi,
                  // Include complete Aaro data
                  aaroCompleteData: model,
              }
            : {
                  Price: 0,
                  StokAdi: stockName,
                  StokKodu: sku,
                  // No complete data available for invalid items
                  aaroCompleteData: null,
              };
        handleBasket(item);
    };

    return (
        <MDButton
            onMouseEnter={async () => {
                setShouldFetch(true);
                await queryClient.prefetchQuery({
                    queryKey: ['fetchAaroStockPrice', stockID],
                    queryFn: () => fetchAaroStockPrice(stockID),
                    staleTime: 60 * 1000,
                });
            }}
            variant="gradient"
            color="success"
            size="xl"
            onClick={handleClick}
            iconOnly
        >
            <Icon>shopping_cart</Icon>
        </MDButton>
    );
}

// const AddToBasket = connectHitInsights(aa)(Add);

export default AddToBasket;
